
import { Record } from 'immutable';

const UNIQUE_FAKE_ID = 'FAKEID';

const DistrictRecord = Record({
    id: '',
    nom: '',
    region: '',
});

class District extends DistrictRecord {

    get id() {
        return this.get('id')
    }
    get region() {
        return this.get('region')
    }
    get nom() {
        return this.get('nom')
    }
    
    constructor(props = {}) {
        super(({
            ...props,

        }));
    }

    setId(id) {
        return this.set('id', id)
    }
    setRegion(id) {
        return this.set('region', id)
    }
    setNom(nom) {
        return this.set('nom', nom)
    }
}

export default District;